module.exports = __webpack_public_path__ + "img/seal-manage.59b12856.png";